<template>
  <div class="foresterCount" v-loading="loading" element-loading-text="数据加载中...">
    <div class="search">
      <div>
        <el-page-header v-if="detailModal && isShowBack" @back="goBack" style="padding-right: 15px"></el-page-header>
        <div v-if="!detailModal" style="font-weight: bold; font-size: 20px">全区林长巡林统计</div>
      </div>
      <div>
        <el-select v-if="detailModal" v-model="areaId" @change="areaChange" filterable placeholder="请选择乡镇" size="medium" style="margin-right: 15px">
          <el-option v-for="item in topData.areaBox" :label="item.areaName" :value="item.areaId" :key="item.areaId"></el-option>
        </el-select>
        <el-select v-model="searchForm.timeType" @change="dateChange" placeholder="请选择时间区间" size="medium">
          <el-option label="本月" :value="1"></el-option>
          <el-option label="本年" :value="2"></el-option>
        </el-select>
        <el-date-picker
          size="medium"
          @change="timeChange"
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </div>
    </div>
    <div class="count" v-show="!detailModal">
      <div class="topChart">
        <div id="chart1" class="item"></div>
        <div id="chart2" class="item"></div>
        <div id="chart3" class="item"></div>
        <div id="chart4" class="item"></div>
        <div id="chart5" class="item"></div>
      </div>
      <div class="buttonChart">
        <div class="item">
          <div style="text-align: center; margin-bottom: 10px; font-weight: bold; font-size: 18px">林长人员排行榜</div>
          <div>
            <el-table
              class="table"
              :data="tableData"
              align="center"
              ref="table"
              :row-style="{ cursor: 'pointer' }"
              highlight-current-row
              :header-cell-style="{ background: '#f4f7fe' }"
              v-loading="loading"
              element-loading-text="数据加载中..."
              @row-click="clickRow"
              @sort-change="sortChange"
            >
              <el-table-column prop="userName" label="林长"></el-table-column>
              <el-table-column prop="patrolCount" label="总次数" sortable="custom"></el-table-column>
              <el-table-column prop="patrolTime" label="总时长" sortable="custom"></el-table-column>
              <el-table-column prop="foresterTask" label="任务数量" sortable="custom"></el-table-column>
              <el-table-column prop="foresterTaskExecute" label="执行次数" sortable="custom"></el-table-column>
            </el-table>
            <div class="page">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[5]"
                layout="sizes, prev, pager, next"
                :total="total"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div id="chart6" class="item"></div>
      </div>
    </div>
    <div class="count" v-show="detailModal">
      <div class="topChart">
        <div class="item2">
          <div style="text-align: center; font-weight: bold">{{ detailForm.areaName }}林长统计</div>
          <ul>
            <li>林长人数:{{ detailForm.sumUsers || 0 }}人</li>
            <li>巡林总次数:{{ detailForm.sumPatrol || 0 }}次</li>
            <li>巡林总时长:{{ detailForm.sumTime || 0 }}小时</li>
            <li>任务数量:{{ detailForm.sumReport || 0 }}个</li>
            <li>执行次数:{{ detailForm.sumReport || 0 }}次</li>
          </ul>
        </div>
        <div id="chart7" class="item2"></div>
      </div>
      <div class="buttonChart">
        <div class="item">
          <div style="text-align: center; margin-bottom: 10px; font-weight: bold; font-size: 18px">{{ detailForm.areaName }}巡林人员列表</div>
          <div>
            <el-table
              class="table"
              :data="tableData2"
              align="center"
              ref="table2"
              :row-style="{ cursor: 'pointer' }"
              highlight-current-row
              :header-cell-style="{ background: '#f4f7fe' }"
              v-loading="loading"
              element-loading-text="数据加载中..."
              @row-click="clickRow2"
              @sort-change="sortChange2"
            >
              <el-table-column prop="userName" label="林长"></el-table-column>
              <el-table-column prop="patrolCount" label="总次数" sortable="custom"></el-table-column>
              <el-table-column prop="patrolTime" label="总时长" sortable="custom"></el-table-column>
              <el-table-column prop="foresterTask" label="任务数量" sortable="custom"></el-table-column>
              <el-table-column prop="foresterTaskExecute" label="执行次数" sortable="custom"></el-table-column>
            </el-table>
            <div class="page">
              <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page.sync="currentPage2"
                :page-sizes="[5]"
                layout="sizes, prev, pager, next"
                :total="total2"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div id="chart8" class="item"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GetForesterCount, GetForesterCountByUserLis, GetForesterCountByUserDetails, GetForesterCountByAreaId, GetForesterUserLevel } from '@/api/Forester'
  export default {
    data() {
      return {
        total: 0, // 数据总数
        currentPage: 1, // 当前页数
        pageSize: 5, // 当前查询数据个数
        total2: 0, // 数据总数
        currentPage2: 1, // 当前页数
        searchForm: {
          timeType: 1,
          startTime: '',
          endTime: '',
        }, //搜索表单
        loading: false, // 数据是否处于加载状态
        date: '',
        topData: [], //顶部4个统计图数据
        detailModal: false,
        detailForm: {},
        tableData: [],
        tableData2: [],
        userDetail: {},
        userCode: '',
        areaId: null,
        isShowBack: true,
        rankType: '',
        orderType: '',
        rankType2: '',
        orderType2: '',
        areaName: '',
        userName: '',
        userName2: '',
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
    },
    mounted() {
      GetForesterUserLevel().then((res) => {
        if (res.data.state == 1) {
          if (res.data.data == 0) {
            this.getTopChartData()
            this.getUserList()
            this.detailModal = false
            this.isShowBack = true
          } else {
            this.areaId = res.data.data
            this.getUserList(2)
            this.getPatrolDetail(this.areaId)
            this.detailModal = true
            this.isShowBack = false
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    methods: {
      // 月份更改
      dateChange() {
        if (this.detailModal == true) {
          this.getUserList(2)
          this.getPatrolDetail(this.areaId)
        } else {
          this.getTopChartData()
          this.getUserList()
          this.getUserDetail(this.userCode)
        }
      },
      // 选择时间
      timeChange(e) {
        if (e) {
          this.searchForm.startTime = e[0]
          this.searchForm.endTime = e[1]
        } else {
          this.searchForm.startTime = ''
          this.searchForm.endTime = ''
        }
        if (this.detailModal == true) {
          this.getTopChartData()
          this.getUserList()
          this.getPatrolDetail(this.areaId)
        } else {
          this.getUserDetail(this.userCode)
        }
      },
      // 获取顶部统计图数据
      getTopChartData() {
        let params = {
          timeType: this.searchForm.timeType,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
        }
        this.loading = true
        GetForesterCount(params).then((res) => {
          if (res.data.state == 1) {
            this.topData = res.data.data
            this.initTopChart()
            this.loading = false
          } else {
            this.loading = false
          }
        })
      },
      // 获取总的巡林统计(工作人员)
      getUserList(type) {
        let params = {}
        if (type) {
          params = {
            timeType: this.searchForm.timeType,
            startTime: this.searchForm.startTime,
            endTime: this.searchForm.endTime,
            pageNumber: this.currentPage2,
            pageSize: this.pageSize,
            areaId: this.areaId,
            rankType: this.rankType2,
            orderType: this.orderType2,
          }
        } else {
          params = {
            timeType: this.searchForm.timeType,
            startTime: this.searchForm.startTime,
            endTime: this.searchForm.endTime,
            pageNumber: this.currentPage,
            pageSize: this.pageSize,
            rankType: this.rankType,
            orderType: this.orderType,
          }
        }
        this.loading = true
        GetForesterCountByUserLis(params).then((res) => {
          if (res.data.state == 1) {
            if (type) {
              this.tableData2 = res.data.data.lis
              this.total2 = res.data.data.count
              if (this.tableData2.length > 0) {
                this.$refs.table2.setCurrentRow(this.tableData2[0])
                this.userCode = this.tableData2[0].userCode
                this.userName2 = this.tableData2[0].userName
                this.getUserDetail(this.userCode, 2)
              }
            } else {
              this.tableData = res.data.data.lis
              this.total = res.data.data.count
              if (this.tableData.length > 0) {
                this.$refs.table.setCurrentRow(this.tableData[0])
                this.userCode = this.tableData[0].userCode
                this.userName = this.tableData[0].userName
                this.getUserDetail(this.userCode)
              }
            }
            this.loading = false
          } else {
            this.loading = false
          }
        })
      },
      // 获取个人巡林详情统计(工作人员)
      getUserDetail(userCode, type) {
        let params = {
          timeType: this.searchForm.timeType,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
          userCode,
        }
        GetForesterCountByUserDetails(params).then((res) => {
          if (res.data.state == 1) {
            this.userDetail = res.data.data
            if (type) {
              setTimeout(() => {
                let myChart8 = this.$echarts.init(document.getElementById('chart8'))
                let option8 = {
                  title: {
                    text: this.userName2 + '巡林详情',
                    left: 'center',
                  },
                  xAxis: {
                    type: 'category',
                    data: this.userDetail.dateName,
                  },
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'shadow',
                    },
                  },
                  legend: {
                    bottom: 10,
                    left: 'center',
                    data: ['任务执行次数', '巡林时长'],
                  },
                  yAxis: [
                    {
                      type: 'value',
                    },
                  ],

                  series: [
                    {
                      name: '任务执行次数',
                      type: 'bar',
                      tooltip: {
                        valueFormatter: function (value) {
                          return value + '次'
                        },
                      },
                      data: this.userDetail.foresterTaskExecute,
                    },
                    {
                      name: '巡林时长',
                      type: 'bar',
                      tooltip: {
                        valueFormatter: function (value) {
                          return value + '小时'
                        },
                      },
                      data: this.userDetail.timeCount,
                    },
                  ],
                }
                myChart8.clear()
                myChart8.setOption(option8)
              }, 300)
            } else {
              let myChart6 = this.$echarts.init(document.getElementById('chart6'))
              let option6 = {
                title: {
                  text: this.userName + '任务巡林详情',
                  left: 'center',
                },
                xAxis: {
                  type: 'category',
                  data: this.userDetail.dateName,
                },
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow',
                  },
                },
                legend: {
                  bottom: 10,
                  left: 'center',
                  data: ['任务执行次数', '巡林时长'],
                },
                yAxis: [
                  {
                    type: 'value',
                  },
                ],

                series: [
                  {
                    name: '任务执行次数',
                    type: 'bar',
                    tooltip: {
                      valueFormatter: function (value) {
                        return value + '次'
                      },
                    },
                    data: this.userDetail.foresterTaskExecute,
                  },
                  {
                    name: '巡林时长',
                    type: 'bar',
                    tooltip: {
                      valueFormatter: function (value) {
                        return value + '小时'
                      },
                    },
                    data: this.userDetail.timeCount,
                  },
                ],
              }
              myChart6.clear()
              myChart6.setOption(option6)
            }
          }
        })
      },
      areaChange() {
        this.getPatrolDetail(this.areaId)
      },
      goBack() {
        let myChart7 = this.$echarts.init(document.getElementById('chart7'))
        let myChart8 = this.$echarts.init(document.getElementById('chart8'))
        myChart7.dispose()
        myChart8.dispose()
        this.currentPage2 = 1
        this.total2 = 0
        this.detailModal = false
      },
      // 初始化顶部统计图数据
      initTopChart() {
        let myChart1 = this.$echarts.init(document.getElementById('chart1'))
        let myChart2 = this.$echarts.init(document.getElementById('chart2'))
        let myChart3 = this.$echarts.init(document.getElementById('chart3'))
        let myChart4 = this.$echarts.init(document.getElementById('chart4'))
        let myChart5 = this.$echarts.init(document.getElementById('chart5'))
        // 指定图表的配置项和数据
        let option1 = {
          title: {
            text: '巡林次数',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}次',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.topData.patrolCountData,
          },
          series: [
            {
              name: '巡林次数',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.topData.patrolCount,
            },
          ],
        }
        let option2 = {
          title: {
            text: '巡林时长',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}小时',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.topData.patrolTimeData,
          },
          series: [
            {
              name: '巡林时长',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.topData.patrolTime,
            },
          ],
        }
        let option3 = {
          title: {
            text: '林长人员',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}人',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.topData.foresterUsersData,
          },
          series: [
            {
              name: '林长人员',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.topData.foresterUsers,
            },
          ],
        }
        let option4 = {
          title: {
            text: '任务数量',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}件',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.topData.foresterTaskData,
          },
          series: [
            {
              name: '任务数量',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.topData.foresterTask,
            },
          ],
        }
        let option5 = {
          title: {
            text: '任务执行次数',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}件',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.topData.foresterTaskExecuteData,
          },
          series: [
            {
              name: '任务执行次数',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.topData.foresterTaskExecute,
            },
          ],
        }
        // 使用刚指定的配置项和数据显示图表。

        myChart1.setOption(option1)
        myChart2.setOption(option2)
        myChart3.setOption(option3)
        myChart4.setOption(option4)
        myChart5.setOption(option5)

        myChart1.on('click', (params) => {
          this.areaId = params.data.areaId
          this.getPatrolDetail(this.areaId)
        })
        myChart2.on('click', (params) => {
          this.areaId = params.data.areaId
          this.getPatrolDetail(this.areaId)
        })
        myChart3.on('click', (params) => {
          this.areaId = params.data.areaId
          this.getPatrolDetail(this.areaId)
        })
        myChart4.on('click', (params) => {
          this.areaId = params.data.areaId
          this.getPatrolDetail(this.areaId)
        })
        myChart5.on('click', (params) => {
          this.areaId = params.data.areaId
          this.getPatrolDetail(this.areaId)
        })
      },
      // 获取详情
      getPatrolDetail(areaId) {
        let params = {
          timeType: this.searchForm.timeType,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
          areaId,
        }
        GetForesterCountByAreaId(params).then((res) => {
          if (res.data.state == 1) {
            this.detailForm = res.data.data
            this.detailModal = true
            this.getUserList(1)
            setTimeout(() => {
              let myChart7 = this.$echarts.init(document.getElementById('chart7'))
              let myChart8 = this.$echarts.init(document.getElementById('chart8'))
              let option7 = {
                title: {
                  text: `${this.detailForm.areaName ? this.detailForm.areaName : ''}信息折线图`,
                  left: 'center',
                },
                xAxis: {
                  type: 'category',
                  data: this.detailForm.dateName,
                },
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow',
                  },
                },
                legend: {
                  bottom: 10,
                  left: 'center',
                  data: ['巡查次数', '巡查时长', '任务执行次数'],
                },
                yAxis: { type: 'value' },
                series: [
                  {
                    name: '巡查次数',
                    type: 'line',
                    stack: 'Total',
                    data: this.detailForm.patrolCount,
                  },
                  {
                    name: '巡查时长',
                    type: 'line',
                    stack: 'Total',
                    data: this.detailForm.timeCount,
                  },
                  {
                    name: '任务执行次数',
                    type: 'line',
                    stack: 'Total',
                    data: this.detailForm.foresterTaskExecute,
                  },
                ],
              }
              let option8 = {
                title: {
                  text: this.userName2 + '巡林详情',
                  left: 'center',
                },
                xAxis: {
                  type: 'category',
                  data: ['1号', '2号', '3号', '4号', '5号', '6号'],
                },
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow',
                  },
                },
                legend: {
                  bottom: 10,
                  left: 'center',
                  data: ['任务执行次数', '巡林时长'],
                },
                yAxis: [
                  {
                    type: 'value',
                    name: '次数',
                    axisLabel: {
                      formatter: '{value} 次',
                    },
                  },
                ],

                series: [
                  {
                    name: '任务执行次数',
                    type: 'bar',
                    tooltip: {
                      valueFormatter: function (value) {
                        return value + '次'
                      },
                    },
                    data: this.userDetail.foresterTaskExecute,
                  },
                  {
                    name: '巡林时长',
                    type: 'bar',
                    tooltip: {
                      valueFormatter: function (value) {
                        return value + '小时'
                      },
                    },
                    data: this.userDetail.timeCount,
                  },
                ],
              }
              myChart7.setOption(option7)
              myChart8.setOption(option8)
            }, 300)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      // table排序
      sortChange(column) {
        this.rankType = column.prop
        this.orderType = column.order
        this.getUserList()
      },
      // table行点击
      clickRow(row) {
        this.userName = row.userName
        this.userCode = row.userCode
        this.getUserDetail(this.userCode)
      },
      clickRow2(row) {
        this.userName2 = row.userName
        this.userCode = row.userCode
        this.getUserDetail(this.userCode, 1)
      },
      sortChange2(column) {
        this.rankType2 = column.prop
        this.orderType2 = column.order
        this.getUserList(1)
      },
      // 分页查询
      handleSizeChange(e) {
        this.pageSize = e
        this.getUserList()
      },
      handleCurrentChange(e) {
        this.currentPage = e
        this.getUserList()
      },
      // 分页查询
      handleSizeChange2(e) {
        this.pageSize = e
        this.getUserList(1)
      },
      handleCurrentChange2(e) {
        this.currentPage = e
        this.getUserList(1)
      },
    },
  }
</script>
<style lang="less" scoped>
  .foresterCount {
    height: 100%;
    .search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      .el-select {
        margin-right: 30px;
        width: 220px;
      }
    }
    .count {
      // padding: 0px 30px 0px 30px;
      height: calc(100vh - 165px);
      margin: 10px;
      .topChart {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50%;
        padding-bottom: 20px;
        .item {
          width: 20%;
          height: 100%;
          // margin-light: 10px;
        }
        .item2 {
          width: 50%;
          height: 100%;
          ul {
            padding: 0;
            margin: 0;
            margin-top: 20px;
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li {
              // width: 40%;
              width: 150px;
              height: 150px;
              border: 1px solid #ccc;
              border-radius: 50%;
              text-align: center;
              list-style: none;
              margin-bottom: 15px;
              font-size: 14px;
              font-weight: bold;
              line-height: 150px;
              // .title {
              // 	width: 100px;
              // 	text-align: right;
              // }
            }
          }
        }
      }
      .buttonChart {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // margin-top: 20px;
        height: 50%;
        .item {
          width: 50%;
          height: 100%;
          .table {
            width: 100%;
            height: calc(100% - 34px);
          }
          .page {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 10px;
            justify-content: right;
            // margin: 0px 10px;
            // margin-top:4px ;
          }
        }
      }
    }
  }
</style>
<style lang="less">
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
  }
</style>
